import Link from '@components/v2/ui/Link/Link';
import StatusChip from '@components/v2/ui/StatusChip/StatusChip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from '../../translation/TranslationContext';
import type { ActivityFeedPhrase as ActivityFeedPhraseModel } from '../utils/activityFeedPhrase.types';

interface ActivityFeedPhraseProps {
  phrase: ActivityFeedPhraseModel;
}

const ActivityFeedPhrase = ({ phrase }: ActivityFeedPhraseProps) => {
  const { formatMessage, translate } = useTranslation();

  const values = phrase.actorLabel
    ? { ...phrase.values, actor: translate(phrase.actorLabel) }
    : phrase.values;

  const renderRef = (chunks: ReactNode) => {
    if (!phrase.refHref) {
      return (
        <Typography component="span" variant="inherit">
          {chunks}
        </Typography>
      );
    }

    return (
      <Link color="text.primary" underline="always" to={phrase.refHref}>
        {chunks}
      </Link>
    );
  };

  return (
    <>
      {formatMessage(
        { id: phrase.key },
        {
          ...values,
          status: phrase.status ? (
            <Box component="span" sx={{ transform: 'translateY(-1px)', display: 'inline-block' }}>
              <StatusChip {...phrase.status} size="small" component="span" />
            </Box>
          ) : null,
          ref: renderRef,
        },
      )}
    </>
  );
};

export default ActivityFeedPhrase;
